export default __webpack_public_path__ + "static/media/document-verification.40d129d6.png";